export const getViewMode = state => state.viewMode;

export const isEditor = state => getViewMode(state) === 'editor';
export const isPreview = state => getViewMode(state) === 'preview';
export const isSite = state => getViewMode(state) === 'site';
export const isSeo = state => getViewMode(state) === 'viewer-seo';
export const isAdi = state => getViewMode(state) === 'onboarding';
